import { useEffect } from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';

import { PermissionsEnum } from '@/auth/interfaces';
import { EstadosOrdenTrabajoEnumChoice, ROUTER_PATHS } from '@/shared';
import { useCheckPermissions, useLoaders } from '@/shared/hooks';
import { AlertSeverityEnum } from '@/shared/interfaces';
import { useUiStore } from '@/store/ui';
import SaveOrdenTrabajoAsignadaTecCorporativo from '../../shared/components/SaveOrdenTrabajoCorporativo/SaveOrdenTrabajoAsignadaTecCorporativo';
import { useGetOrdenServicioCorporativoById } from '@/shared/actions/erp/tecnico/orden_servicio_corporativo';

export type InstalacionAsignadaTecnicoCorporativoPageProps = {};

const InstalacionAsignadaTecnicoCorporativoPage: React.FC<
  InstalacionAsignadaTecnicoCorporativoPageProps
> = () => {
  const returnUrlInstalacionesTecnicoPage =
    ROUTER_PATHS.tecnico.ordenenTrabajoNav;
  useCheckPermissions(PermissionsEnum.api_change_ordentrabajo);

  const navigate = useNavigate();

  const setAlert = useUiStore(s => s.setAlert);

  const { id } = useParams();
  const { data, isLoading, isRefetching } = useGetOrdenServicioCorporativoById(id!);
  useLoaders(isLoading || isRefetching);

  // validate state
  useEffect(() => {
    if (!data?.data?.id_orden_servicio_corporativo) return;
    if (
      data?.data?.estado_solicitud_servicio_corporativo !==
      EstadosOrdenTrabajoEnumChoice.EN_ESPERA
    ) {
      setAlert(
        true,
        'La orden de trabajo no tiene el estado correcto',
        AlertSeverityEnum.error
      );
      navigate(returnUrlInstalacionesTecnicoPage);
    }
  }, [data?.data?.id_orden_servicio_corporativo]);

  // se comenta el isRefetching x el invalidateQuery en form
  if (isLoading /* || isRefetching */) return null;
  if (!data?.data?.id_orden_servicio_corporativo)
    return <Navigate to={returnUrlInstalacionesTecnicoPage} />;

  return (
    <SaveOrdenTrabajoAsignadaTecCorporativo
      title="Orden de Trabajo Corporativo"
      ordentrabajo={data.data}
    />
  );
};

export default InstalacionAsignadaTecnicoCorporativoPage;
